import React from "react";
import {
  seriesContacts,
  categories,
  getGroupedStackSeries,
  data,
} from "./data";
import { ChartsSetWrapper } from "../../../../../components";

const ColumnList = () => {
  return (
    <div className="flex-1 flex overflow-auto">
      <div className="flex-1  grid grid-cols-2 auto-rows-[400px] gap-4">
        <ChartsSetWrapper
          title="Column Chart with Scrolling"
          type="column"
          series={seriesContacts}
          categories={categories}
          options={{
            padding: { left: 60 },
            axis: {
              x: {
                scroll: { enabled: true },
              },
            },
            bar: {
              fixedHeight: 15,
              gap: 1,
              radius: 0,
              groupGap: 40,
            },
          }}
        />
        <ChartsSetWrapper
          title="Column Chart with Scrolling"
          type="column"
          series={seriesContacts}
          categories={categories}
          options={{
            padding: { left: 60 },
            axis: {
              x: {
                scroll: { enabled: true },
              },
              y: {
                clampMinZero: true,
              },
            },
            bar: {
              fixedWidth: 45,
              gap: 0,
              radius: 0,
              groupGap: 15,
              stacked: true,
            },
            showLabels: {
              show: true,
            },
          }}
        />

        <ChartsSetWrapper
          title="Column Chart with Options"
          type="column"
          series={seriesContacts}
          categories={categories}
          options={{
            colors: ["primary-800", "info-500", "danger-500"],
            padding: { top: 40, right: 30, bottom: 40, left: 60 },
            axis: {
              color: "gray-200",
              labelColor: "gray-400",
              edgePadding: 50,
              x: {
                scroll: { enabled: true },
                gridLines: 6,
                //clampMinZero: true,
              },
            },
            grid: {
              color: "info-100",
              dasharray: "1 1",
              strokeWidth: 2,
              horizontal: true,
              vertical: true,
              background: "primary-50",
            },
            showLabels: {
              show: true,
              valueDisplay: "value",
              color: "gray-400",
              fontSize: 8,
              strategy: "hide",
            },
            background: "gray-100",

            legend: {
              mode: "select",
            },
          }}
        />

        <ChartsSetWrapper
          title="Column Chart with Group Stacked"
          type="column"
          series={getGroupedStackSeries()}
          categories={categories}
          options={{
            padding: { left: 60 },
            axis: {
              x: {
                scroll: { enabled: true },
              },
              y: {
                clampMinZero: true,
              },
            },
            bar: {
              fixedWidth: 75,
              gap: 10,
              radius: 0,
              groupGap: 1,
              stacked: true,
              grouped: true,
            },
            legend: { mode: "select" },
          }}
        />
      </div>
    </div>
  );
};

export default ColumnList;
